<template>
  <div
    :class="['peer-view-wrapper', { 'myself': myself, 'disabled-video': !enabledVideo }]"
    :style="enabledVideo ? '' : `background-image: url(${require('@/assets/images/logo.webp')})`"
  >
    <div class="peer-view-content">
      <video
        :srcObject.prop="enabledVideo ? mediaStream : null"
        class="peer-video"
        autoplay
        muted
        playsinline
      />
      <div class="media-state">
        <v-fa
          @click="onClickMic"
          :icon="enabledMic ? 'microphone' : 'microphone-slash'"
          :class="{ 'clickable': myself }"
          size="lg"
        />
        <v-fa
          @click="onClickVideo"
          :icon="enabledVideo ? 'video' : 'video-slash'"
          :class="{ 'clickable': myself }"
          size="lg"
        />
      </div>
      <audio v-if="!myself" :srcObject.prop="mediaStream" autoplay/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PeerView',
  props: {
    myself: {
      type: Boolean,
      default: false
    },
    mediaStream: MediaStream,
    enabledMic: Boolean,
    enabledVideo: Boolean
  },
  methods: {
    onClickMic: function() {
      if (!this.myself) return
      this.$emit('onClickMic')
    },
    onClickVideo: function() {
      if (!this.myself) return
      this.$emit('onClickVideo')
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.peer-view-wrapper {
  margin: 0.2rem;
  position: relative;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  box-shadow: 0 5px 12px 2px rgba(17,17,17,0.5);
  background-color: #FFFFFF80;

  &:before {
    content:"";
    display: block;
    padding-top: 66%;
  }

  &.myself .media-state {
    opacity: 1;
  }

  &.disabled-video {
    background-size: 60% auto;
  }

  .peer-view-content {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .peer-video {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.media-state {
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 1;
  color: white;
  opacity: 0.5;
  display: flex;
  justify-content: flex-end;

  svg {
    filter: drop-shadow(1px 1px 2px #000);
    margin: 0 7px 5px 0;
    width: 10%;

    @include mq(md) {
      margin: 0 15px 10px 0;
      width: auto;
    }
  }
}
</style>
